import { render } from "./ClickBankIcon.vue?vue&type=template&id=cb2bf6e6"
import script from "./ClickBankIcon.vue?vue&type=script&lang=js"
export * from "./ClickBankIcon.vue?vue&type=script&lang=js"
script.render = render

export default script